import React from "react";
import SortableTree, { toggleExpandedForAll } from "@nosferatu500/react-sortable-tree";
import NewElementDialog from "@app/widgets/dialogs/NewElementDialog";
import { defaultServiceContext } from "@app/contexts";
import { createIntentHierarchyTree } from "@app/utilities";
const maxDepth = 5;

const alertNodeInfo = ({ node, path, treeIndex }) => {
  const objectString = Object.keys(node)
    .map(k => (k === "children" ? "children: Array" : `${k}: '${node[k]}'`))
    .join(",\n   ");

  global.alert(
    "Info passed to the button generator:\n\n" +
    `node: {\n   ${objectString}\n},\n` +
    `path: [${path.join(", ")}],\n` +
    `treeIndex: ${treeIndex}`
  );
};

const { intentService } = defaultServiceContext;

export class HierarchicalIntentPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchString: "",
      searchFocusIndex: 0,
      searchFoundCount: null,
      treeData: createIntentHierarchyTree(window.apm.serialized),
      globalIntents: this.props.globalIntents
    };
  }

  handleTreeOnChange = treeData => {
    this.setState({ treeData });
  }
  handleSearchOnChange = e => {
    this.setState({
      searchString: e.target.value.toUpperCase().replace(/ /g, "_")
    });
  };

  selectPrevMatch = () => {
    const { searchFocusIndex, searchFoundCount } = this.state;
    this.setState({
      searchFocusIndex:
        searchFocusIndex !== null
          ? (searchFoundCount + searchFocusIndex - 1) % searchFoundCount
          : searchFoundCount - 1
    });
  };
  getIntent = id => {
    var intentIndex = window.apm.serialized.components.intents.findIndex(el => el.id === id);
    if (intentIndex !== -1)
      return window.apm.serialized.components.intents[intentIndex];
  };
  selectNextMatch = () => {
    const { searchFocusIndex, searchFoundCount } = this.state;
    this.setState({
      searchFocusIndex: searchFocusIndex !== null ? (searchFocusIndex + 1) % searchFoundCount : 0
    });
  };

  toggleNodeExpansion = expanded => {
    this.setState(prevState => ({
      treeData: toggleExpandedForAll({
        treeData: prevState.treeData,
        expanded
      })
    }));
  };
  createIntent = treeData => {
    const newIntent = intentService.initializeIntent();
    const treeDom = $("#tl_container");
    NewElementDialog.addElement(treeDom, newIntent);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.globalIntents.length !== this.state.globalIntents.length) {
      this.setState({
        treeData: createIntentHierarchyTree(window.apm.serialized)
      });
    }
  }

  render() {
    const {
      treeData,
      searchString,
      searchFocusIndex,
      searchFoundCount
    } = this.state;
    return (
      <div className="wrapper">
        <div className="bar-wrapper">
          <div className={"tag-new"}>
            <div className={"row"}>
              <div className={"col-md-12"}>
                <div className={"col-md-12"}>
                  <button className="w2ui-btn primary" onClick={this.toggleNodeExpansion.bind(this, true)}>Expand all</button>
                  <button className="w2ui-btn warning" onClick={this.toggleNodeExpansion.bind(this, false)}>Collapse all</button>

                  <div className={"col-md-3 hierarchical-search"}>
                    <div>
                      <i className="fe icon-x input-suffix-icon clear-button" onClick={() => { this.getDomSelf().find("#globalIntent_q").val(""); this.getDomSelf().find(".clear-button").hide(); this.doFilter(""); }} />
                      <input type="search" id="globalIntent_q" className="form-component v-marginal search" placeholder={window.l.settings.search_intent} onChange={this.handleSearchOnChange} />
                    </div>
                  </div>
                  <div className={"col-md-3 hierarchical-count"}>
                    {this.state.searchString !== "" && this.state.searchFoundCount > 0 && (<label>{searchFocusIndex} / {searchFoundCount}</label>)}
                    {this.state.searchString !== "" && this.state.searchFoundCount > 0 && (<button className=" w2ui-btn primary previous" onClick={this.selectPrevMatch}>Previous</button>)}
                    {this.state.searchString !== "" && this.state.searchFoundCount > 0 && (<button className=" w2ui-btn primary next" onClick={this.selectNextMatch}>Next</button>)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ height: 800, width: 1200, paddingTop: "50px", marginBottom: "30px" }}>
          <SortableTree treeData={this.state.treeData} onChange={this.handleTreeOnChange} onMoveNode={({ node, treeIndex, path, nextParentNode, prevPath }) => global.console.debug(
            "node:", node,
            "treeIndex:", treeIndex,
            "path:", path,
            "prevPath:", prevPath,
            "nextParentNode:", nextParentNode
          )
          }
            //maxDepth={maxDepth}
            searchQuery={searchString}
            searchFocusOffset={searchFocusIndex}
            canDrag={false}
            //canDrag={({ node }) => !node.noDragging}
            //canDrop={({ nextParent }) => !nextParent || !nextParent.noChildren}
            searchFinishCallback={matches =>
              this.setState({
                searchFoundCount: matches.length,
                searchFocusIndex:
                  matches.length > 0 ? searchFocusIndex % matches.length : 0
              })
            }
            isVirtualized={true}
            generateNodeProps={rowInfo => ({
              buttons: [<button className="btn btn-outline-success" style={{ verticalAlign: "middle" }} onClick={() => window.apm.postEventToCurrentView({ target: "request-component-panel", event: this.getIntent(rowInfo.node.id) })}><i className={"fe icon-info"} /></button>]
            })}
          />
        </div>
      </div>
    );
  }
}
